import { ButtonGroup, Button as MUIButton, Grid, Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material'
import React, { useState } from 'react'
import HierarchyView from './HierarchyView'
import LanguageStrings from '../../i18n/locales'
import { Button } from '../../components/Button'
import './Hierarchy.css'
import CloseIcon from '@mui/icons-material/Close'

export const ZoomControls = ({ flowTreeInstance, currentZoom, defaultViewportX = 150 }: { flowTreeInstance: any, currentZoom: number, defaultViewportX?: number }): JSX.Element => {
  return (
    <ButtonGroup className='custom-button' color="primary" aria-label="outlined primary button group" sx={{ p: 0.3, backgroundColor: '#1B1B1B' }}>
      <MUIButton variant='contained' sx={{ mr: 0.5, ':disabled': { color: '#ffff' } }} disabled={Math.round(currentZoom * 100) === 30} onClick={() => { flowTreeInstance?.zoomOut() }}>-</MUIButton>
      <MUIButton variant='contained' sx={{ mr: 0.5, ':disabled': { color: '#ffff' } }} disabled={Math.round(currentZoom * 100) === 200} onClick={() => { flowTreeInstance?.zoomIn() }}>+</MUIButton>
      <Grid alignItems={'center'} sx={{ mr: 0.5, px: 0.5, display: 'flex', fontFamily: 'Honeywell Sans Web' }} >{Math.round(currentZoom * 100)}%</Grid>
      <MUIButton variant='contained' sx={{ textTransform: 'none' }} onClick={() => {
        flowTreeInstance?.setViewport({
          x: defaultViewportX ?? 150,
          y: 45,
          zoom: 0.6
        })
      }}>Reset</MUIButton>
    </ButtonGroup>
  )
}
const WraperHierarchy = (props: AllProps): JSX.Element => {
  const [currentZoom, setCurrentZoom] = useState<number>(0)
  const [flowTreeInstance, setFlowTreeInstance] = useState<any>()
  const ViewSiteStrings = LanguageStrings().SiteManagementCollectionStrings.TableComponent

  const handleInstance = React.useCallback((instance: any) => {
    setFlowTreeInstance(instance)
    setCurrentZoom(instance.getZoom())
  }, [])

  const handleZoomChange = React.useCallback((zoom: number) => {
    setCurrentZoom(zoom)
  }, [])

  return (
  <>
   <Dialog sx={{
     '& .MuiDialog-paper': {
       backgroundColor: '#252525', // Set your desired background color
       color: '#f0f0f0'
     },
     width: 'unset',
     minWidth: 'unset',
     maxWidth: 'unset'
   }}
   maxWidth={'lg'}
    fullWidth={false} open={props.id !== ''} onClose={() => { props.viewPopup('') }} disableEscapeKeyDown={true}>
         <DialogTitle>
            <Grid item sx={{ display: 'flex', justifyContent: 'space-between' }} >
              <Grid item xs={10} >
                <p>{ViewSiteStrings.HierarchyView}</p>
              </Grid>
              <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                <CloseIcon data-testid="close-icon" className="custom-device-close-icon" onClick={() => { props.viewPopup('') }} />
              </Grid>
            </Grid>
        </DialogTitle>
        <DialogContent sx={{ height: { sm: '80vh', md: '50vh', lg: '60vh' }, width: { sm: '90vw', md: '70vw', lg: '60vw', xl: '50vw' } }}>
            <HierarchyView site={props.site} id={props.id} setInstance={handleInstance} onZoomChange={handleZoomChange} />
        </DialogContent>
        <DialogActions>
          <Grid container paddingX={1} justifyContent={'space-between'} display={'flex'} alignItems={'center'} >
              <Grid item >
                <ZoomControls flowTreeInstance={flowTreeInstance} currentZoom={currentZoom} />
              </Grid>
              <Grid item >
                <Button type='hollow' sx={{ margin: '0px' }} dataTestId="close-btn-click" onClick={() => { props.viewPopup('') }}>
                  {ViewSiteStrings.Close}
                </Button>
              </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
  </>)
}

interface InputProps {
  id: any
  site: any
  handleClose: any
  viewPopup: (val: string) => void
}

type AllProps = InputProps

export const MemoWraperHierarchy = React.memo(WraperHierarchy)
